import React from "react";
import { EditView } from "./EditView";

export function InventoryListRow(props) {
  const id = props.item.BarID + "-" + props.item.ID;
  const handleRowClick = (id) => {
    props.setSelectedRow(props.selectedRow === id ? null : id);
  };

  const isRowSelected = props.selectedRow === id;
  const isAdmin = localStorage.getItem("Admin") == 1;

  return (
    <React.Fragment>
      {isRowSelected && isAdmin && props.active ? (
        <EditView
          object={props.item}
          id={props.id}
          refresh={props.refresh}
          type="InventoryData"
          key={props.id}
        />
      ) : (
        <tr key={id} className="hoverButton" onClick={() => handleRowClick(id)}>
          <td>{props.item.Name}</td>
          <td>{props.item.Price}</td>
          <td>{props.item.Amount}</td>
          <td>{(props.item.Price * props.item.Amount).toFixed(2) + " kr"}</td>
        </tr>
      )}
    </React.Fragment>
  );
}
